import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, Box, Grid, Typography } from '@material-ui/core/';
import { Helmet } from "react-helmet";
import Alert from '@material-ui/lab/Alert';
import { accountVerification } from '../../../../store/actions/auth/auth'
import { Loading } from '../../../atoms/commonLoadings';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import apiConfigs from '../../../../config/config';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  logo: {
    width: 201
  },
  successMessage: {
    fontSize: 36,
    textAlign: 'center',
    font: 'normal normal bold 36px/26px Roboto',
    letterSpacing: 0,
    color: '#f2f2fa',
    opacity: 1,
    lineHeight:1
  },
  learnmore: {
    textAlign: 'center',
    font: 'normal normal normal 18px/30px Roboto',
    letterSpacing: -0.27,
    color: '#f2f2fa',
    fontSize: 18,
  },
  link: {
    color: '#fdca42',
    textDecoration: 'underline',
    fontWeight: 600
  },
  textCenter: {
    textAlign: 'center',
    color: '#f2f2fa'
  },
  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#fdca42'
  },
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '0',
    paddingRight: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#6667ab',
    width: '100vw',
    backgroundImage: 'url(/assets/images/known/celebrate_header.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
}))

const KnownAccountVerification = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState(false);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const email: any = new URLSearchParams(location.search).get("email")
    if (email) {
      const request = { email: email }
      dispatch(accountVerification(apolloClient.client, request, (response: any) => {
        setLoading(false);
        let errormsg = "Problem while verify account, Please try again."
        if (response) {
          if (response.status && response.status == 'true') {
            setSuccessMsg(true)
            setErrorMsg(response.message)
          } else {
            if(response.messagecode && response.messagecode === 'alreadyConfirmed') {
              history.push("/user/login");
            } else {
              if (response.message) {
                errormsg = response.message
              }
              setSuccessMsg(false)
              setErrorMsg(errormsg)
            }
          }
        } else {
          setSuccessMsg(false)
          setErrorMsg(errormsg)
        }
      })
      )
    } else {
      setSuccessMsg(false)
      setErrorMsg("Invalid url link, please try with valid link")
    }
  }, [])

  return (
    
    <React.Fragment>
      <Helmet title="Account verification" />
      <div className={classes.layout}>
        {
          loading ?
          <Loading /> : 
          <>

            <Grid container spacing={3}>
            <Grid item xs={12} sm={6} >

            <Box>
              
              <div>
                { errorMsg && (
                  successMsg ? (
                    <>

                    <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>Your account is now <span className={classes.logoFont}>known</span>!</Typography>

                    </>
                  ) : (
                    <>
                      <br/>
                      <Alert icon={false} className="error-alert" severity={!successMsg ? 'error' : 'success'}>{errorMsg}</Alert>
                      <br/>
                      </>
                  )
                )}
              </div>
              <p className={classes.learnmore}>
                To learn more about what we do visit:
                <br/>
                <Link to={{ pathname:apiConfigs.COMPANY_URL }} className={classes.link}  target='_blank'>www.getimmersion.com</Link>
              </p>
            </Box>
            </Grid>
            </Grid>
          </>
        }
      </div>
      
    </React.Fragment>
  )
};

export default KnownAccountVerification;
